<template>
  <div>
    <base-heading :level="2" class="title-card">
      Top Links Clicked
    </base-heading>
    <template v-if="loading">
      <base-skeleton
        v-for="n in 5"
        :key="n"
        :opacity="0 + (1 /n)"
        class="py-3 "
      >
        <div class="d-flex align-items-center justify-content-between w-100">
          <div
            class="skeleton__item py-2"
            style="max-width: 50%"
          />
          <div
            class="mr-5"
            style="width: 10%;"
          >
            <div class="d-flex align-items-center flex-column justify-content-center">
              <div
                class="skeleton__item py-1"
                style="max-width: 50px"
              />
              <div
                class="skeleton__item py-1 "
                style="max-width: 30px"
              />
            </div>
          </div>
        </div>
      </base-skeleton>
    </template>
    <template v-else>
      <template v-if="entries.length === 0">
        <base-text size="l">
          No data for this range of date
        </base-text>
      </template>
      <template
        v-for="(entry, index) in entries"
        v-else
      >
        <slot name="cell">
          <base-cell :key="index" high-contrast class="pt-3 pb-4">
            <div class="link__container text-left" @click="trackURL(entry.url)">
              <base-text
                trim
                light
                size="md"
                class="link clickable"
              >
                <a
                  :href="entry.url"
                  target="_blank"
                >{{ entry.url }}</a>
              </base-text>
            </div>
            <div
              class="clickable text-center ml-auto"
              @click="onViewDetail(entry)"
            >
              <base-text light size="s">
                CLICKS
              </base-text>
              <base-text light>
                {{ entry.clicks }}
              </base-text>
            </div>
          </base-cell>
        </slot>
      </template>
    </template>
    <client-click-events-modal-container
      v-if="showModal"
      :url="modalUrl"
      :count="modalCount"
      @closed="onModalClosed"
    />
  </div>
</template>
<script>
import ClientClickEventsModalContainer from '@/components/Widgets/ClientHistory/ClientClickEventsModalContainer';

export default {

  name: 'TopLinksClicked',
  components: { ClientClickEventsModalContainer },
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalUrl: '',
      showModal: false,
      modalCount: 0,
    };
  },
  computed: {

  },
  methods: {
    onViewDetail({ url, clicks }) {
      this.trackURL(url);
      this.modalUrl = url;
      this.modalCount = clicks;
      this.showModal = true;
    },
    onModalClosed() {
      this.showModal = false;
      this.modalUrl = null;
      this.modalCount = null;
    },
    trackURL(url) {
      this.$mixpanel.track('click', {
        url,
        account_id: this.$store.state.account.user.user.email,
      });
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .skeleton__container {
  background-color: rgba($clementine, 0.2) !important;
}
::v-deep .skeleton__item {
  background-color: rgba(black, 0.1) !important;
}
.link {
  line-height: 18px;
  letter-spacing: 0.59px;

  &__container {
    width: calc(100% - 60px);
    max-width: 530px;
  }
  a {
    color: $black;
    border-bottom: 1px solid rgba($black, 0.6);

    @media (-webkit-min-device-pixel-ratio: 2){
      border-bottom: none;
      position: relative;
      &:before{
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0;
        background-image: linear-gradient(to bottom, $black 0%, $black 61%, transparent 61%);
        background-size: 100% 1px;
      }
    }
    &:hover {
      text-decoration: inherit;
    }
  }
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
}
</style>
